module.exports = __webpack_public_path__ + "static/media/Checkpoint-logo.59bf0732.png";